import styled from '@emotion/styled';
import ArrowRight from '../../../assets/icons/arrowRight.svg?react';
import { Link } from 'react-router-dom';
import { fadeIn, fadeInDown, fadeOutUp } from '../../common/data/animations';
import { RebrandTheme } from '../../common/models/common.models';
import { TSkeleton } from '@toluna/design-system';

const transitionHeader = 'all 0.3s';

export const Wrapper = styled.div<{ isontop: boolean; breakLine?: boolean, isInitialized?: boolean }>`
    background-color: #ffffffd9;
    box-shadow: 0px 0px 20px 0px #0000000f;
    display: flex;
    position: fixed;
    top: 0;
    width: 100%;
    min-height: ${props => (props.isontop ? '78px' : '46px')};
    border-bottom: 1px solid #f1f1f1;
    z-index: 90;
    box-sizing: border-box;
    white-space: ${props => (props.breakLine ? 'pre-line' : undefined)};
    transition: all 0.4s ease;
    animation: ${fadeIn} 0.6s ease both;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    & > * {
        animation: ${fadeIn} 0.4s ease both;
    }

    &.ti-header-show {
        animation: ${fadeInDown} 0.4s ease both;
    }

    &.ti-header-hide {
        animation: ${fadeOutUp} 0.4s ease both;
        pointer-events: none;
    }

    ::view-transition-old(root),
    ::view-transition-new(root) {
        animation-duration: 0.3s;
    }

    pointer-events: ${props => (props.isInitialized ? 'auto' : 'none')};
`;

export const LogoWrapper = styled.a<{ isontop: string; theme?: any }>`
    outline: none;
    transition: ${transitionHeader};
    padding: ${props =>
        props.isontop === 'true' ? props.theme.header.logoImage.paddingIsOnTop : props.theme.header.logoImage.padding};
    > div {
        width: ${props => props.theme.header.logoImage.width};
        height: ${props => props.theme.header.logoImage.height};
        transition: ${transitionHeader};
        transform: ${props => (props.isontop === 'true' ? '' : 'scale(0.8)')};
    }
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        background-color: #efefef;
    }
    &:focus-visible {
        outline: 4px solid ${props => props.theme.header.outlineColor};
        outline-offset: -4px;
        border-radius: 8px;
        transition: none;
    }
`;

export const LinkedLogoWrapper = LogoWrapper.withComponent(Link);

export const Logo = styled.div<{ isontop?: boolean; theme?: any }>`
    background-image: url(${props => props.theme.header.logoImage.imageUrl});
    background-repeat: no-repeat;
    background-size: contain;
`;

export const TextTitle = styled.h2<{ isontop: boolean }>`
    font-family: 'MuseoSans-700';
    font-size: ${props => (props.isontop ? '28px' : '20px')};
    margin: 0;
    transition: all 0.3s;
    padding: ${props => (props.isontop ? '16px' : '8px')} 48px;
`;

export const MenuItemsWrapper = styled.div`
    display: flex;
`;

export const LinkedMenuItemWrapper = styled(Link)<{ theme?: RebrandTheme }>`
    display: flex;
    align-items: center;
    color: #60738f;
    padding: 0 32px;
    cursor: pointer;
    transition: all 0.3s;
    text-decoration: none;
    &:hover {
        background-color: #efefef;
        color: #000;
    }

    &:focus {
        text-decoration: none;
    }

    &:focus-visible {
        border: none;
        outline: 4px solid ${props => props.theme.header.outlineColor};
        outline-offset: -4px;
        border-radius: 8px;
        transition: none;
    }
`;

export const MenuItemWrapper = styled.a`
    display: flex;
    align-items: center;
    color: #60738f;
    padding: 0 32px;
    cursor: pointer;
    transition: all 0.3s;
    text-decoration: none;
    &:hover {
        background-color: #efefef;
        color: #000;
        text-decoration: none;
    }
    &:focus {
        text-decoration: none;
    }
`;

export const MenuItemIcon = styled.span`
    font-size: 20px;
    padding-right: 8px;
`;

export const MenuItemText = styled.span<{ theme?: any }>`
    font-family: ${props => props.theme.header.myProjects.fontFamily};
    font-size: 12px;
    font-weight: 600;
`;

export const FlexSpace = styled.div`
    flex: 1;
`;

export const ItemMenuWrapper = styled.div<{ isSelected?: boolean; theme?: any }>`
    border-left: 1px solid #e7e8e9;
    display: flex;
    cursor: pointer;
    color: ${props => props.theme.header.createButton.color};
    transition: all 0.3s;
    background-color: ${props =>
        props.isSelected ? props.theme.header.createButton.backgroundColorHover : 'transparent'};
    &:hover {
        background-color: ${props => props.theme.header.createButton.backgroundColorHover};
        color: ${props => props.theme.header.createButton.colorHover};
    }
    &:focus-visible {
        outline: 4px solid ${props => props.theme.header.outlineColor};
        outline-offset: -4px;
        border-radius: 8px;
        transition: none;
    }
    text-transform: ${props => props.theme.header.createButton.textTransform};
`;

export const ItemMenuButton = styled.div<{ theme?: any }>`
    font-family: ${props => props.theme.header.createButton.fontFamily};
    font-size: 12px;
    font-weight: 700;
    padding: 0 32px;
    display: flex;
    align-items: center;
`;

export const CreateMenuButtonIcon = styled.span<{ theme?: any }>`
    font-size: 13px;
    margin-right: 8px;
    color: ${props => props.theme.header.createButton.iconColor};
`;

export const ArrowRightIcon = styled(ArrowRight)`
    margin-right: 8px;
`;

export const UserMenuWrapper = styled.div<{ theme?: RebrandTheme }>`
    display: flex;
    border-left: 1px solid #e7e8e9;
    transition: all 0.3s;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    padding: 0 24px 0 32px;
    cursor: pointer;
    &:hover {
        background-color: #efefef;
    }
    &:focus-visible {
        outline: 4px solid ${props => props.theme.header.outlineColor};
        outline-offset: -4px;
        border-radius: 8px;
        transition: none;
    }
`;

export const UserMenuText = styled.div`
    display: flex;
    flex-direction: column;
`;

export const UserMenuUserName = styled.div<{ theme?: any }>`
    color: #60738f;
    font-family: ${props => props.theme.header.userMenu.fontFamily};
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 119px;
    font-size: 13px;
`;

export const UserMenuIcon = styled.div<{ theme?: any }>`
    padding-left: 24px;
    color: ${props => props.theme.header.userMenu.iconColor};
    font-size: 14px;
`;

export const PremiumIcon = styled.span`
    font-size: 12px;
    padding-right: 6px;
    color: #60738f;
`;

export const ButtonToggleWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
`;

export const ButtonToggleText = styled.div<{ theme?: any }>`
    cursor: pointer;
    font-family: ${props => props.theme.header.createButton.fontFamily}, sans-serif;
    // font-family: ${props => props.theme.mainFontFamily};
    font-weight: 600;
    font-size: 12px;
    // color:#102833;
    color: ${props => props.theme.mainColor};
`;

export const ButtonToggle = styled.div<{ theme?: any }>`
    cursor: pointer;
    border-radius: 50%;
    border: 2px solid ${props => props.theme.mainColor};
    width: 13px;
    height: 13px;
    background-color: ${props => props.theme.mainColor};
    margin: 0px 5px;
`;

export const NotificationsWrapper = styled.div<{ isOnTop: boolean; fixedNotification?: boolean }>`
    position: ${({ fixedNotification }) => (fixedNotification ? 'fixed' : 'sticky')};
    top: ${({ isOnTop }) => (isOnTop ? '78px' : '46px')};
    width: 100%;
    z-index: 89;
    transition: top 0.4s ease;

    & > div > div {
        animation: ${fadeIn} 0.4s ease both;
    }
`;

export const NotificationsSubstrate = styled.div<{ isShow: boolean }>`
    padding-top: ${({ isShow }) => (isShow ? '55px' : '0')};
    transition: padding-top 0.4s ease;
`;

export const StyledSkeleton = styled(TSkeleton)<{ theme?: RebrandTheme }>`
    &.MuiSkeleton-root {
        background-color: ${({ theme }) => theme.skeletonColor} !important;
    }
`;
